/**
 * @fileoverview DELETE handler for the "/custom_objects/:type_name/:external_id/object_relationships"
 * endpoint. The edge is identified by its natural key — direction, the related object's type and
 * external id, and the relationship kind — passed as query params (the internal row id is never used).
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameExternalIdObjectRelationships } from "./constants";
import type { DeleteCustomObjectsTypeNameExternalIdObjectRelationshipsParams } from "./types";

export const deleteCustomObjectsTypeNameExternalIdObjectRelationships = reactQueryMutationAdapter(
  customObjectsTypeNameExternalIdObjectRelationships,
  ({
    typeName,
    externalId,
    direction,
    targetTypeName,
    targetExternalId,
    relKind,
  }: DeleteCustomObjectsTypeNameExternalIdObjectRelationshipsParams): Promise<Record<string, never>> => {
    return fetch(
      `/custom_objects/${encodeURIComponent(typeName)}/${encodeURIComponent(externalId)}/object_relationships`,
      "DELETE",
      {},
      {
        queryParams: {
          direction,
          target_type_name: targetTypeName,
          target_external_id: targetExternalId,
          rel_kind: relKind,
        },
      },
      { propagateFetchRequestError: false }
    );
  }
);
